import React from "react";
import intl from "react-intl-universal";
import { InfoItem } from "../../components/infobar";
import Base64toImage from "./base64toImage";

const DriverInfo = ({ driver, web = true }) => {
  return (
    <div>
      {web && <div className="divider-horizontal" />}
      <div
        className="group"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "4px",
        }}
      >
        <div className="group-header" style={{ marginBottom: "4px" }}>
          {intl.get("driverInfo")}
        </div>
        <div className="row">
          <Base64toImage code={driver.photo || driver.thumbnail} />
        </div>
        {driver.driver_name_surname}
      </div>
    </div>
  );
};

export default DriverInfo;
